import axios from 'axios'
import { getAuthToken } from 'src/utils/helpers/authStorage'

export const API_BASE = import.meta.env.VITE_API_BASE

const instance = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  timeout: 120000, // 2min for long polling
})

instance.interceptors.request.use((config) => {
  const token = getAuthToken()
  if (token) {
    config.headers = config.headers || {}
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// export function isAuthenticated(req): boolean {
//   return false
// }

export default instance
